import {
  deleteWithCheckingToken,
  getAccessToken,
  getWithCheckingToken,
  postFormDataWithCheckingToken,
  postWithCheckingToken,
  putWithCheckingToken,
} from './NetworkingAuth'
import {getWithTimeout} from './networking'
import {API_URI, app_secret, app_token} from '../constants/constants'
import {GIFT_CERTIFICATE_MODE} from '../views/Listing/constant'
import {toast} from 'react-toastify'

export function userLogin(body) {
  return postWithCheckingToken(`${API_URI}login`, {}, body)
}

export async function resetPassword(body) {
  const res = await postWithCheckingToken(`${API_URI}resetAdminPassword`, {}, body)
  if (res.ok) {
    toast('request sent successfully', {type: 'success'})
  }
  return res
}

// CHARITY NOMINATIONS API
export function getCharityNominations(
  page = 1,
  per_page = 10,
  search = '',
  status = ''
) {
  const params = new URLSearchParams({
    page: page.toString(),
    per_page: per_page.toString()
  })

  if (search) params.append('search', search)
  if (status && status !== 'all') params.append('status', status)

  return getWithCheckingToken(
    `${API_URI}admin/charities/nominations?${params.toString()}`,
    {}
  )
}

export function getCharityNomination(id) {
  return getWithCheckingToken(`${API_URI}admin/charities/nominations/${id}`, {})
}

export async function approveCharityNomination(id) {
  const res = await postWithCheckingToken(
    `${API_URI}admin/charities/nominations/${id}/approve`,
    {},
    {}
  )
  if (res.ok) {
    toast('Charity nomination approved successfully.', {type: 'success'})
  }
  return res
}

export async function rejectCharityNomination(id) {
  const res = await postWithCheckingToken(
    `${API_URI}admin/charities/nominations/${id}/reject`,
    {},
    {}
  )
  if (res.ok) {
    toast('Charity nomination rejected successfully.', {type: 'success'})
  }
  return res
}

export function getSsoVersion(url) {
  return getWithTimeout(url, {})
}

export function getListingType() {
  return getWithCheckingToken(`${API_URI}admin/listingType`, {})
}

export function getAdminVenue() {
  return getWithCheckingToken(`${API_URI}admin/venue`)
}

export function retrievePromotions() {
  return getWithCheckingToken(`${API_URI}admin/retrievePromotions`)
}

export function getPagingVouchers(
  page = 1,
  limit = 10,
  keyword = '',
  showAll = 0,
  voucherType = 'all',
  sortBy = 'desc',
  orderBy = 'id',
) {
  return getWithCheckingToken(`${API_URI}admin/vouchers?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&orderBy=${orderBy}&page=${page}&paginate_number=${limit}&voucher_type=${voucherType}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}&filter=voucher`)
}

export function getPagingListing(
  type_id,
  venue_id,
  page = 1,
  limit = 10,
  showAll = 0,
  keyword = '',
  sortBy = 'asc',
  orderBy = 'status',
) {
  return getWithCheckingToken(`${API_URI}admin/paginateListing?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&expired=0&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&type_id=${type_id}&venue_id=${venue_id}&keyword=${keyword}`)
}

export function getActiveListing(type_id, venue_id) {
  return getWithCheckingToken(`${API_URI}admin/activeListing?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&type_id=${type_id}${
    !venue_id ? '' : `&venue_id=${venue_id}`
  }`)
}

export function duplicateListing(listing_id) {
  return postWithCheckingToken(`${API_URI}admin/duplicateListing`, {}, {listing_id})
}

export function displayOrder(display_order, venue_id, type_id) {
  return postWithCheckingToken(
    `${API_URI}admin/displayOrder`,
    {},
    {display_order: JSON.stringify(display_order), venue_id, type_id},
  )
}

export async function changeListingStatus(id, status) {
  const res = await postWithCheckingToken(
    `${API_URI}admin/changeListingStatus`,
    {},
    {
      id,
      status,
    },
  )
  if (res.ok) {
    toast(`update status successfully.`, {type: 'success'})
  }
  return res
}

export async function getDataListing(id) {
  const res = await getWithCheckingToken(
    `${API_URI}admin/listing/${id}?token=${getAccessToken()} &app_secret=${app_secret}&app_token=${app_token}`,
  )
  if (typeof res?.data?.extra_settings === 'string') {
    res.data.extra_settings = JSON.parse(res.data.extra_settings)
  }
  if (typeof res?.data?.payload === 'string') {
    res.data.payload = JSON.parse(res.data.payload)
  }
  res.data.products = res.data.products.map((_) => ({
    ..._,
    ..._.product,
    product: undefined,
    mode: GIFT_CERTIFICATE_MODE.NOT_MODIFIED,
  }))
  res.data.schedules = res.data.schedules.map((_) => ({
    ..._,
    mode: GIFT_CERTIFICATE_MODE.NOT_MODIFIED,
  }))
  return res
}

export async function postListingData(id = '', body) {
  const res = await postFormDataWithCheckingToken(`${API_URI}admin/listing/${id}`, {}, body)
  if (res.ok) {
    toast(`create listing successfully.`, {type: 'success'})
  }
  return res
}

export function getTier(showAll = 0) {
  return getWithCheckingToken(`${API_URI}admin/tier?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&show_all=${showAll}`)
}

export async function createVouchers(body) {
  const res = await postFormDataWithCheckingToken(
    `${API_URI}admin/product?token=${getAccessToken()}`,
    {},
    body,
  )
  if (res.ok) {
    toast('Voucher created successful.', {type: 'success'})
  }
  return res
}

export async function updateVouchers(id, body) {
  const res = await postFormDataWithCheckingToken(
    `${API_URI}admin/product/${id}?token=${getAccessToken()}`,
    {},
    body,
  )
  if (res.ok) {
    toast('Updating voucher setup is successful.', {type: 'success'})
  }
  return res
}

export function getVoucherSetup() {
  return getWithCheckingToken(
    `${API_URI}bepoz/voucherSetups/?token=${getAccessToken()} &app_secret=${app_secret}&app_token=${app_token}`,
  )
}

export function postSyncVenues() {
  return postWithCheckingToken(`${API_URI}admin/syncVenueBepoz`, {}, {})
}

export function postSyncVouchers() {
  return postWithCheckingToken(`${API_URI}admin/vouchers/sync`, {}, {})
}

export function getVouchers() {
  return getWithCheckingToken(`${API_URI}admin/product?token=${getAccessToken()}`)
}

export function getVouchersList() {
  return getWithCheckingToken(`${API_URI}admin/vouchers/list?token=${getAccessToken()}`)
}

export function postMarkItAsDone(body) {
  return postWithCheckingToken(`${API_URI}admin/markItAsDone`, {}, body)
}

export function postSaveComment(body) {
  return postWithCheckingToken(`${API_URI}admin/saveComment`, {}, body)
}

export function getPrizePromotions() {
  return getWithCheckingToken(`${API_URI}bepoz/prizePromotions?token=${getAccessToken()}`)
}

export function getBepozGroups() {
  return getWithCheckingToken(`${API_URI}bepoz/bepozGroups`)
}

export function getOperatorId() {
  return getWithCheckingToken(`${API_URI}bepoz/bepozOperatorList`)
}

export function getTillId() {
  return getWithCheckingToken(`${API_URI}bepoz/bepozWorkstationList`)
}

// PRODUCT API
export function getPagingProduct(
  page = 1,
  limit = 10,
  showAll = 0,
  keyword = '',
  sortBy = 'asc',
  orderBy = 'id',
  filter = 'ticket',
) {
  return getWithCheckingToken(`${API_URI}admin/paginateProduct?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&expired=0&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}&filter=${filter}`)
}

export async function changeProductStatus(id, status) {
  const res = await postWithCheckingToken(
    `${API_URI}admin/changeProductStatus`,
    {},
    {
      id,
      status,
    },
  )
  if (res.ok) {
    toast('Status updated successfully.', {type: 'success'})
  }
  return res
}

export function getProduct(product_id) {
  return getWithCheckingToken(`${API_URI}admin/product/${product_id}`, {})
}

export function duplicateProduct(product_id) {
  return postWithCheckingToken(`${API_URI}admin/duplicateProduct`, {}, {product_id})
}

export async function postProductData(id = '', body) {
  const res = await postFormDataWithCheckingToken(`${API_URI}admin/product/${id}`, {}, body)
  if (res.ok) {
    toast('Product updated successfully', {type: 'success'})
  }
  return res
}

export function deleteProduct(id = '') {
  return deleteWithCheckingToken(`${API_URI}admin/product/${id}`, {})
}

// MEMBER API
export function getPagingMember(
  page = 1,
  limit = 10,
  showAll = 0,
  keyword = '',
  sortBy = 'asc',
  orderBy = 'id',
) {
  return getWithCheckingToken(`${API_URI}admin/member?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&expired=0&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}`)
}

export function getMember(id = '') {
  return getWithCheckingToken(`${API_URI}admin/member/${id}`, {})
}

export function getMemberLog(id = '', page = 1) {
  return getWithCheckingToken(`${API_URI}admin/memberLogs?member_id=${id}&page=${page}`, {})
}

export function postResendConfirmation() {
  return postFormDataWithCheckingToken(`${API_URI}admin/resendConfirmationEmails`, {})
}

export function postResendConfirmationMember(body) {
  return postWithCheckingToken(`${API_URI}admin/resendConfirmationMember`, {}, body)
}

export function postReSyncMember(body) {
  return postWithCheckingToken(`${API_URI}admin/triggerMemberSync`, {}, body)
}

export function postResetUdid(body) {
  return postWithCheckingToken(`${API_URI}admin/member/resetUDID`, {}, body)
}

export async function postPhotoUploadStatus(body) {
  const res = await postWithCheckingToken(`${API_URI}admin/isPhotoUploaded`, {}, body)
  if (res.ok) {
    toast('Photo upload status updated successfully', {type: 'success'})
  }
  return res
}

export function postBroadcastGroupNotification(body) {
  return postWithCheckingToken(`${API_URI}admin/broadcastGroupNotification`, {}, body)
}

export function postSendBroadcastSystemNotification(body) {
  return postWithCheckingToken(`${API_URI}admin/sendBroadcastSystemNotification`, {}, body)
}

export function postPushNotification(body) {
  return postWithCheckingToken(`${API_URI}admin/pushNotification`, {}, body)
}

// STAFF API
export function getPagingStaff(page = 1, limit = 10, showAll = 0, keyword = '') {
  return getWithCheckingToken(`${API_URI}admin/paginateStaff?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&expired=0&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&keyword=${keyword}`)
}

export function postStaff(id = '', body) {
  return postFormDataWithCheckingToken(`${API_URI}admin/staff/${id}`, {}, body)
}

export function changeStaffStatus(id, active) {
  return postWithCheckingToken(
    `${API_URI}admin/changeStaffStatus`,
    {},
    {
      id,
      active,
    },
  )
}

// SYSTEM NOTIFICATION API
export function getPagingSystemNotification(
  page = 1,
  limit = 10,
  showAll = 0,
  keyword = '',
  sortBy = 'asc',
  orderBy = 'id',
) {
  return getWithCheckingToken(`${API_URI}admin/paginateSystemNotification?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&expired=0&page=${page}&paginate_number=${limit}
  &orderBy=${orderBy}&sortBy=${sortBy}&keyword=${keyword}&showAll=${showAll}`)
}

export async function getSystemNotification(id = '') {
  if (id) {
    const res = await getWithCheckingToken(
      `${API_URI}admin/systemNotification/${id}?token=${getAccessToken()}`,
    )
    res.data.payload = JSON.parse(res.data.payload)
    res.data.item = JSON.parse(res.data.item)
    return res
  }
  return getWithCheckingToken(`${API_URI}admin/systemNotification?token=${getAccessToken()}`)
}

export function postSystemNotification(id = '', data) {
  const body = {...data}
  if (id && id !== 'create') {
    return putWithCheckingToken(`${API_URI}admin/systemNotification/${id}`, {}, body)
  } else {
    return postWithCheckingToken(`${API_URI}admin/systemNotification`, {}, body)
  }
}

// ENQUIRY API
export function getPagingEnquiry(page = 1, limit = 10, showDone = false, sortBy = 'desc', orderBy = 'id') {
  return getWithCheckingToken(`${API_URI}admin/listingEnquiry?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&sortBy=${sortBy}&orderBy=${orderBy}&expired=0&page=${page}&paginate_number=${limit}&show_done=${
    showDone ? 1 : 0
  }`)
}

export function deleteListingEnquiry(id = '') {
  return deleteWithCheckingToken(`${API_URI}admin/listingEnquiry/${id}`, {})
}

// FAQ API
export function getPagingFAQ(page = 1, limit = 10, showAll = 0, sortBy = 'desc', orderBy = 'id') {
  return getWithCheckingToken(`${API_URI}admin/faq?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&expired=0&page=${page}&sortBy=${sortBy}&orderBy=${orderBy}&paginate_number=${limit}&showAll=${showAll}`)
}

export function changeFAQStatus(id, status) {
  return postWithCheckingToken(`${API_URI}admin/changeFaqStatus`, {}, {id, status})
}

export function postFAQ(id = '', body) {
  if (id) {
    return putWithCheckingToken(`${API_URI}admin/faq/${id}`, {}, body)
  } else {
    return postWithCheckingToken(`${API_URI}admin/faq`, {}, body)
  }
}

// FRIEND REFERRAL API
export function getPagingFriendReferral(page = 1, limit = 10, sortBy = 'desc', orderBy = 'id') {
  return getWithCheckingToken(`${API_URI}admin/paginateFriendReferrals?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&expired=0&page=${page}&sortBy=${sortBy}&orderBy=${orderBy}&paginate_number=${limit}`)
}

export function postShowFriendReferral(body) {
  return postWithCheckingToken(`${API_URI}admin/showFriendReferrals`, {}, body)
}

// SURVEY API
export function getPagingSurvey(page = 1, limit = 10, keyword = '') {
  return getWithCheckingToken(`${API_URI}admin/paginateSurvey?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&page=${page}&paginate_number=${limit}&keyword=${keyword}`)
}

export function postCheckSurveyQuestion(body) {
  return postWithCheckingToken(`${API_URI}admin/checkSurveyQuestion`, {}, body)
}

export function postSurveyGenerateReport(body) {
  return postWithCheckingToken(`${API_URI}admin/generateSurveyReport`, {}, body)
}

export function getSurvey(id) {
  return getWithCheckingToken(`${API_URI}admin/survey/${id}`)
}

export function getSurveyDetail(id) {
  return getWithCheckingToken(`${API_URI}admin/surveyDetail/${id}`)
}

export function deleteSurvey(id = '') {
  return deleteWithCheckingToken(`${API_URI}admin/survey/${id}`, {})
}

export async function postSurvey(id = '', body) {
  const params = {...body}
  let res
  let message = ''
  if (id) {
    params.tiers = JSON.stringify(params.tiers)
    params.questions = JSON.stringify(params.questions)
    params.date_expiry = new Date(params.date_expiry).toISOString()
    res = await putWithCheckingToken(`${API_URI}admin/survey/${id}`, {}, params)
    message = 'Survey updated successfully'
  } else {
    params.tiers = encodeURI(JSON.stringify(params.tiers))
    params.questions = encodeURI(JSON.stringify(params.questions))
    res = await postWithCheckingToken(
      `${API_URI}admin/survey?${Object.entries(params)
        .filter(([key, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')}`,
      {},
    )
    message = 'Survey created successfully'
  }
  if (res.ok) {
    toast(message, {type: 'success'})
  }
  return res
}

// QUESTION API
export function getQuestion(id = '') {
  return getWithCheckingToken(`${API_URI}admin/question${id ? `/${id}` : ''}?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}`)
}

export function postQuestion(id = '', body) {
  if (id) {
    const params = {...body}
    params.answers = JSON.stringify(params.answers)
    params.sequence = JSON.stringify(params.sequence)
    return putWithCheckingToken(`${API_URI}admin/question/${id}`, {}, params)
  } else {
    return postFormDataWithCheckingToken(`${API_URI}admin/question`, {}, body)
  }
}

export function deleteQuestion(id = '') {
  return deleteWithCheckingToken(`${API_URI}admin/question/${id}`, {})
}

// ANSWER API
export function getAnswer() {
  return getWithCheckingToken(`${API_URI}admin/answer?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}`)
}

export function postAnswer(id = '', body) {
  if (id) {
    return putWithCheckingToken(`${API_URI}admin/answer/${id}`, {}, body)
  } else {
    return postWithCheckingToken(`${API_URI}admin/answer`, {}, body)
  }
}

export function deleteAnswer(id = '') {
  return deleteWithCheckingToken(`${API_URI}admin/answer/${id}`, {})
}

// TRANSACTION API
export function getPagingTransaction(
  page = 1,
  limit = 10,
  venue_id = 0,
  filter = 'none',
  sortBy = 'asc',
  orderBy = 'id',
) {
  return getWithCheckingToken(`${API_URI}admin/transaction?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&sortBy=${sortBy}&orderBy=${orderBy}&page=${page}&paginate_number=${limit}&venue_id=${venue_id}&filter=${filter}`)
}

export function getTransaction(id = '') {
  return getWithCheckingToken(`${API_URI}admin/transaction/${id}`)
}

export function getInvoice(id = '') {
  const url = `${API_URI}admin/invoice/${id}?token=${getAccessToken()}&app_secret=${app_secret}&app_token=${app_token}`
  const oReq = new XMLHttpRequest()
  oReq.open('GET', url, true)
  oReq.responseType = 'arraybuffer'
  oReq.onload = function (oEvent) {
    const blob = new Blob([oReq.response], {type: 'application/pdf'})
    const URL = window.URL || window.webkitURL
    const dataUrl = URL.createObjectURL(blob)
    window.open(dataUrl, '_blank')
  }
  oReq.send()
}

export function getDailySales() {
  return getWithCheckingToken(`${API_URI}admin/getDailySales`)
}

export function getWeeklySales() {
  return getWithCheckingToken(`${API_URI}admin/getWeeklySales`)
}

export function getMonthlySales() {
  return getWithCheckingToken(`${API_URI}admin/getMonthlySales`)
}

export function getQuarterlySales() {
  return getWithCheckingToken(`${API_URI}admin/getQuarterlySales`)
}

export function getYearlySales() {
  return getWithCheckingToken(`${API_URI}admin/getYearlySales`)
}

export function getQuarterlyYearlySales() {
  return getWithCheckingToken(`${API_URI}admin/getQuarterlyYearlySales`)
}

// SETTING API
export function getSetting() {
  return getWithCheckingToken(`${API_URI}admin/setting`)
}

export function postSetting(body) {
  return postWithCheckingToken(`${API_URI}admin/setting`, {}, body)
}

export async function postTierSetting(body) {
  return postWithCheckingToken(`${API_URI}admin/tierSetting`, {}, body)
}

/**
 * Persist the Registration QR code appearance (background colour + centre logo) for a single
 * tier. The saved values come back on the tier record from `getTier`, so the editor can
 * re-hydrate them per tier. Sent as multipart form-data so `qr_code_image` can carry the raw
 * cropped image Blob (an unchanged image is sent back as its existing URL string).
 *   POST admin/tier/{id}/qr-code  form-data: {qr_code_color, qr_code_image}
 */
export async function postTierQrCode(id, body) {
  const res = await postFormDataWithCheckingToken(`${API_URI}admin/tier/${id}/qr-code`, {}, body)
  if (res.ok) {
    toast('QR code settings saved.', {type: 'success'})
  }
  return res
}

export function postUploadGalleryPhoto(body) {
  return postFormDataWithCheckingToken(`${API_URI}admin/uploadGalleryPhoto`, {}, body)
}

export function putRole(id, body) {
  return putWithCheckingToken(`${API_URI}admin/role/${id}`, {}, body)
}

export function getRoles() {
  return getWithCheckingToken(`${API_URI}admin/role`)
}

export async function createRole(body) {
  const res = await postWithCheckingToken(`${API_URI}admin/role`, {}, body)
  if (res.ok) {
    toast(`Role created successfully.`, {type: 'success'})
  }
  return res
}

// Location
export function getPagingVenue(page = 1, limit = 10, showAll, showVenue, showStores, keyword = '') {
  return getWithCheckingToken(`${API_URI}admin/paginateVenue?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&page=${page}&paginate_number=${limit}&showAll=${showAll}&bepozVenue=${showVenue}&bepozStore=${showStores}&keyword=${keyword}`)
}

export async function postVenue(body) {
  const res = await postWithCheckingToken(`${API_URI}admin/venue`, {}, body)
  if (res.ok) {
    toast('Location added successfully', {type: 'success'})
  }
  return res
}

export async function updateVenue(id, payload) {
  const res = await putWithCheckingToken(`${API_URI}admin/venue/${id}`, {}, payload)
  if (res.ok) {
    toast('POS location updated successfully', {type: 'success'})
  }
  return res
}

// Silent: these run as soon as an admin opens the Oolio flow, before anything is
// saved. On an org with no Oolio organisation ID the backend answers with an
// error, and a global toast on a screen the admin has not submitted yet reads as
// a failure of the page rather than as a missing setting. The Oolio tab shows the
// message inline instead (MP-3311).
export function getOomLocations() {
  return getWithCheckingToken(`${API_URI}admin/oom/locations`, {}, true)
}

export function getOomLocationStore(locationId) {
  return getWithCheckingToken(`${API_URI}admin/oom/locations/${locationId}/store`, {}, true)
}

export async function postChangeVenueStatus(body) {
  const res = await postWithCheckingToken(`${API_URI}admin/changeVenueStatus`, {}, body)
  if (res.ok) {
    toast('POS location status updated successfully', {type: 'success'})
  }
  return res
}

//Role
export function getPaginateRole(page = 1, limit = 10) {
  return getWithCheckingToken(`${API_URI}admin/paginateRole?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&page=${page}&paginate_number=${limit}`)
}

export function getEmail(id = '') {
  return getWithCheckingToken(`${API_URI}admin/email/${id}`)
}

export function putEmail(id = '', body) {
  return putWithCheckingToken(`${API_URI}admin/email/${id}`, {}, body)
}

//Location Tag
export function getPaginateVenueTag(page = 1, limit = 10, keyword = '') {
  return getWithCheckingToken(`${API_URI}admin/paginateVenueTag?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&page=${page}&paginate_number=${limit}&keyword=${keyword}`)
}

export function getVenueTag(id = '') {
  return getWithCheckingToken(`${API_URI}admin/venueTag/${id}`)
}

export async function postVenueTag(body) {
  const params = {...body, venuesPivot: encodeURIComponent(JSON.stringify(body.venuesPivot))}
  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')
  const res = await postWithCheckingToken(`${API_URI}admin/venueTag?${queryString}`)
  if (res.ok) {
    toast('Location tag added successfully', {type: 'success'})
  }
  return res
}

export async function putVenueTag(id, body) {
  const res = await putWithCheckingToken(`${API_URI}admin/venueTag/${id}`, {}, body)
  if (res.ok) {
    toast('Location tag updated successfully', {type: 'success'})
  }
  return res
}

export async function postChangeVenueTagStatus(body) {
  const res = await postWithCheckingToken(`${API_URI}admin/changeVenueTagStatus`, {}, body)
  if (res.ok) {
    toast('Location tag status updates successfully', {type: 'success'})
  }
  return res
}

export async function postChangeVenueTagHideInApp(body) {
  const res = await postWithCheckingToken(`${API_URI}admin/changeVenueTagHideInApp`, {}, body)
  if (res.ok) {
    toast('Location tag updates successfully', {type: 'success'})
  }
  return res
}

// IGT API
export function postTestIGT(body) {
  return postWithCheckingToken(`${API_URI}testerigt`, {}, body)
}

export function postTestWSDL(body) {
  return postWithCheckingToken(`${API_URI}testerigtwsdl`, {}, body)
}

// DASHBOARD API
export function postNewDashboard(body) {
  return postWithCheckingToken(`${API_URI}admin/newDashboard`, {}, body)
}

export function getRetrievePromotions() {
  return getWithCheckingToken(`${API_URI}admin/retrievePromotions`)
}

export function getJoinedMembers(body) {
  return postWithCheckingToken(`${API_URI}admin/getJoinedMembers`, {}, body)
}

export function getListingCounts(body) {
  return postWithCheckingToken(`${API_URI}admin/getListingCounts`, {}, body)
}

export function postRegisteredMembersReport(body) {
  return postWithCheckingToken(`${API_URI}admin/registeredMembersReport`, {}, body)
}

export async function postSendHelpDesk(body) {
  const res = await postWithCheckingToken(`${API_URI}admin/sendHelpDesk`, {}, body)
  toast('Sending email is successful', {type: 'success'})
  return res
}

export async function postClearNotification() {
  const res = await postWithCheckingToken(`${API_URI}admin/clearNotification`)
  if (res.ok) {
    toast('Notification container is clear', {type: 'success'})
  }
  return res
}

export async function putChangePassword(body) {
  const res = await putWithCheckingToken(`${API_URI}admin/password`, {}, body)
  if (res.ok) {
    toast('Changing password is successful', {type: 'success'})
  }
  return res
}

export function getPagingBepozLogs(
  page = 1,
  limit = 10,
  keyword = '',
  startDate,
  endDate,
  logFilter = '*',
  orderBy = 'id',
  sortBy = 'asc',
) {
  return getWithCheckingToken(`${API_URI}admin/getBepozLogs?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &logFilter=${logFilter}&endDate=${endDate}&startDate=${startDate}&sortBy=${sortBy}&keyword=${keyword}`)
}

export function getPagingSystemLogs(page = 1, limit = 10) {
  return getWithCheckingToken(`${API_URI}admin/systemLogs?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&page=${page}&paginate_number=${limit}`)
}

export function getVersion() {
  return getWithCheckingToken(`${API_URI}version?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}`)
}

export function getDllVersion() {
  return getWithCheckingToken(`${API_URI}bepoz/storeProcedureVersionGet`)
}

export function getPosVersion() {
  return getWithCheckingToken(`${API_URI}bepoz/versionGet`)
}

export function getBepozCustomFieldsMetaGet() {
  return getWithCheckingToken(`${API_URI}bepoz/bepozCustomFieldsMetaGet`)
}

export function bepozAccountGet(AccNumber, CardNumber) {
  return postWithCheckingToken(
    `${API_URI}bepoz/bepozAccountGet`,
    {},
    {
      AccNumber,
      CardNumber,
      timestamp: Date.now(),
    },
  )
}

export function listingTypeHide(id, isHide) {
  let endPoint = isHide ? 'listingTypeUnHide' : 'listingTypeHide'
  return postWithCheckingToken(
    `${API_URI}admin/${endPoint}`,
    {},
    {
      id,
    },
  )
}

export function getGamingLog(
  page = 1,
  limit = 10,
  keyword = '',
  startDate,
  endDate,
  logFilter = '*',
  orderBy = 'id',
  sortBy = 'asc',
) {
  return getWithCheckingToken(`${API_URI}admin/getGamingLogs?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &logFilter=${logFilter}&endDate=${endDate}&startDate=${startDate}&sortBy=${sortBy}&keyword=${keyword}`)
}

export function restoreGaming() {
  return getWithCheckingToken(`${API_URI}admin/restoreGamingDefault?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}`)
}

//admin/refreshGamingSettingOdyssey
export function refreshGamingSettingOdy() {
  return getWithCheckingToken(`${API_URI}admin/refreshGamingSettingOdyssey?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}`)
}

//refreshGamingSettingIGT
export async function refreshGamingSettingIGT() {
  const res = await getWithCheckingToken(`${API_URI}admin/refreshGamingSettingIGT?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}`)
  if (res.ok) {
    toast(`IGT signup fields sync successfully `, {type: 'success'})
  }
  return res
}

//callCustomFieldOdyssey
export function testCustomFieldOdy() {
  return getWithCheckingToken(`${API_URI}admin/callCustomFieldOdyssey?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}`)
}

export function getProducts(page = 1, limit = 10, show_hidden = 0, orderBy = 'id', sortBy = 'desc') {
  return getWithCheckingToken(`${API_URI}admin/paginateProduct?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &sortBy=${sortBy}&filter=product&show_hidden=${show_hidden}&showAll=${show_hidden}`)
}

export function createProduct(data) {
  return postWithCheckingToken(`${API_URI}admin/product`, {}, data)
}

export function getProductById(id) {
  return getWithCheckingToken(`${API_URI}admin/product/${id}`)
}

export function updateProduct(id, data) {
  return postFormDataWithCheckingToken(`${API_URI}admin/product/${id}`, {}, data)
}

// SUBSCRIPTION API - Updated to match OpenAPI specification
export function getSubscriptions(page = 1, limit = 10, filters = {}) {
  const {
    keyword = '',
    tier_id = '',
    is_free = '',
    active = '',
    orderBy = 'id',
    sortBy = 'desc'
  } = filters

  const params = new URLSearchParams({
    page: page.toString(),
    paginate_number: limit.toString(),
    orderBy,
    sortBy
  })

  if (keyword) params.append('keyword', keyword)
  if (tier_id) params.append('tier_id', tier_id.toString())
  if (is_free !== '') params.append('is_free', is_free.toString())
  if (active !== '') params.append('active', active.toString())

  return getWithCheckingToken(`${API_URI}admin/subscriptions?${params.toString()}`)
}

export function getAllSubscriptions() {
  return getWithCheckingToken(`${API_URI}admin/subscriptions/list/all`)
}

export function createSubscription(data) {
  return postFormDataWithCheckingToken(`${API_URI}admin/subscriptions`, {}, data)
}

export function getSubscriptionById(id) {
  return getWithCheckingToken(`${API_URI}admin/subscriptions/${id}`)
}

export function updateSubscription(id, data) {
  return postFormDataWithCheckingToken(`${API_URI}admin/subscriptions/${id}`, {}, data)
}

export function deleteSubscription(id) {
  return deleteWithCheckingToken(`${API_URI}admin/subscriptions/${id}`, {})
}

// Legacy function for backward compatibility - maps to update subscription with active status
export function changeSubscriptionStatus(id, active) {
  return postFormDataWithCheckingToken(`${API_URI}admin/subscriptions/${id}`, {}, {active: active ? 1 : 0})
}

// Subscription display order function
export function subscriptionDisplayOrder(display_order) {
  return postWithCheckingToken(
    `${API_URI}admin/subscriptions/update-order`,
    {},
    {subscriptions: display_order},
  )
}

// Charity API functions
export function getCharities(venueId = null) {

  const url = `${API_URI}admin/charities/venues/${venueId}`
  return getWithCheckingToken(url)
}

export function syncCharities(venueId) {
  return postWithCheckingToken(`${API_URI}admin/charities/venues/${venueId}/sync-bepoz`, {}, {})
}

export function updateCharity(venueId, data) {
  return postFormDataWithCheckingToken(`${API_URI}admin/charities/venues/${venueId}`, {}, data)
}

export function updateCharityVenue(venueId, data) {
  return putWithCheckingToken(`${API_URI}admin/charities/venues/${venueId}`, {}, data)
}

export function deleteCharity(id) {
  return deleteWithCheckingToken(`${API_URI}admin/charities/${id}`, {})
}

export function changeCharityStatus(venueId, charity_id, active) {
  return updateCharity(venueId, {charity_id, active})
}

// Charity display order function
export function charityDisplayOrder(venueId, display_order) {
  return postWithCheckingToken(
    `${API_URI}admin/charities/venues/${venueId}/update-order`,
    {},
    {charities: display_order},
  )
}

export function getTriggerAllMemberCustomField() {
  return getWithCheckingToken(`${API_URI}admin/triggerAllMemberCustomField`, {})
}

export function setVenueBepozField(venueId, fieldData) {
  return postWithCheckingToken(`${API_URI}admin/charities/venues/${venueId}/bepoz-field`, {}, fieldData)
}

//Reward feature

export function getRewards(page = 1, limit = 10, showAll = 0, keyword = '', sortBy = 'asc', orderBy = 'id') {
  return getWithCheckingToken(`${API_URI}admin/rewards/settings?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&expired=0&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}`)
}

export function getReward(reward_id) {
  return getWithCheckingToken(`${API_URI}admin/rewards/settings/${reward_id}`, {})
}

export async function updateReward(id, body) {
  const res = await postFormDataWithCheckingToken(`${API_URI}admin/rewards/settings/${id}`, {}, body)
  if (res.ok) {
    toast('Reward was updated successful', {type: 'success'})
  }
  return res
}

export function displayOrderReward() {
  return postWithCheckingToken(`${API_URI}admin/displayOrderReward`, {}, {})
}

export function getActiveReward() {
  return getWithCheckingToken(`${API_URI}admin/activeReward`)
}

export function getProductListPaginate(
  page = 1,
  limit = 10,
  showAll = 0,
  keyword = '',
  sortBy = 'desc',
  orderBy = 'ProductID',
  groupIds = '',
) {
  return getWithCheckingToken(`${API_URI}admin/rewards/products?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}&groupIds=${groupIds}`)
}

export function getProductsGroup() {
  return getWithCheckingToken(`${API_URI}admin/rewards/products/groups`, {}, {})
}

// App wallet
export function uploadP12(body) {
  return postFormDataWithCheckingToken(`${API_URI}admin/wallet/certificates/upload`, {}, body)
}

export function getLastBepozVoucherPush() {
  return getWithCheckingToken(`${API_URI}setting/voucher_notification_runtime`)
}

// Member Profile
export function getMemberProfiles(
  page = 1,
  limit = 10,
  showAll = 0,
  keyword = '',
  sortBy = 'asc',
  orderBy = 'id',
) {
  return getWithCheckingToken(`${API_URI}admin/member-profile/settings?expired=0&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}`)
}

export function getMemberProfileById(id) {
  return getWithCheckingToken(`${API_URI}admin/member-profile/settings/${id}`)
}

export function createNewMemberProfile(data) {
  return postWithCheckingToken(`${API_URI}admin/member-profile/settings`, {}, data)
}

export function updateMemberProfile(id, data) {
  return postWithCheckingToken(`${API_URI}admin/member-profile/settings/${id}`, {}, data)
}

export function getClassifications() {
  return getWithCheckingToken(`${API_URI}pos/classifications`)
}

export function postSyncTierPos() {
  return getWithCheckingToken(`${API_URI}admin/syncTierPos`, {}, {})
}

// Other locations

export async function postOtherLocation(body) {
  const res = await postWithCheckingToken(`${API_URI}admin/other-locations`, {}, body)
  if (res.ok) {
    toast('Location added successfully', {type: 'success'})
  }
  return res
}

export function getOtherLocationsPaginate(
  page = 1,
  limit = 10,
  showAll = 0,
  keyword = '',
  sortBy = 'desc',
  orderBy = 'id',
) {
  return getWithCheckingToken(`${API_URI}admin/other-locations?token=${getAccessToken()}
  &app_secret=${app_secret}&app_token=${app_token}&orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}`)
}

export async function updateOtherLocation(id, body) {
  const res = await putWithCheckingToken(`${API_URI}admin/other-locations/${id}`, {}, body)
  if (res.ok) {
    toast('Venues setting updated successfully', {type: 'success'})
  }
  return res
}

/** GAMES */

export function getListGames({
  orderBy = 'id',
  page = 1,
  limit = 10,
  showAll = 0,
  sortBy = 'desc',
  keyword = '',
}) {
  return getWithCheckingToken(`${API_URI}admin/games?orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}`)
}

export function createGame(body) {
  return postWithCheckingToken(`${API_URI}admin/games`, {}, body)
}

export function updateGame(id, body) {
  return putWithCheckingToken(`${API_URI}admin/games/${id}`, {}, body)
}

export function getGameById(id) {
  return getWithCheckingToken(`${API_URI}admin/games/${id}`, {})
}

/** SwiftPos API */

/** get voucher setup by id */
export function getVoucherSetupById(product_id) {
  return getWithCheckingToken(`${API_URI}admin/vouchers/${product_id}`, {})
}

export async function updateVoucherSetup(id, body) {
  const res = await postFormDataWithCheckingToken(
    `${API_URI}admin/vouchers/${id}?token=${getAccessToken()}`,
    {},
    body,
  )
  if (res.ok) {
    toast('Updating voucher setup is successful.', {type: 'success'})
  }
  return res
}

/** PosPromotions */

export function getListPosPromotions({
  orderBy = 'pos_product_promo_id',
  page = 1,
  limit = 10,
  showAll = 0,
  sortBy = 'desc',
  keyword = '',
}) {
  return getWithCheckingToken(`${API_URI}admin/pospromotions?orderBy=${orderBy}&page=${page}&paginate_number=${limit}
  &showAll=${showAll}&sortBy=${sortBy}&keyword=${keyword}`)
}

export function postSyncPromotions() {
  return postWithCheckingToken(`${API_URI}admin/pospromotions/sync`, {}, {})
}

export function getPosPromotion(id) {
  return getWithCheckingToken(`${API_URI}admin/pospromotions/${id}`, {})
}

export async function updatePosPromotion(id, body) {
  return postFormDataWithCheckingToken(
    `${API_URI}admin/pospromotions/${id}?token=${getAccessToken()}`,
    {},
    body,
  )
}

/**
 * List wallet designs, optionally filtered. With no filters the server returns every row.
 * Filters are passed as query params: platform (apple|android), type (e.g. member), tier_id.
 *   GET admin/wallet/design?platform=apple&type=member
 */
export async function getWalletDesignList({platform, type, tierId} = {}) {
  const params = new URLSearchParams()
  if (platform) params.append('platform', platform)
  if (type) params.append('type', type)
  if (tierId) params.append('tier_id', tierId)
  const qs = params.toString()
  return getWithCheckingToken(`${API_URI}admin/wallet/design${qs ? `?${qs}` : ''}`)
}

/**
 * Get a single wallet design. Without tierId returns the default design for the platform/type;
 * with tierId returns the tier-specific override.
 *   GET admin/wallet/design/{platform}/{type}?tier_id={tierId}
 */
export async function getWalletSetting(platform, type = 'member', tierId) {
  const qs = tierId ? `?tier_id=${tierId}` : ''
  return getWithCheckingToken(`${API_URI}admin/wallet/design/${platform}/${type}${qs}`)
}

/**
 * Upsert a wallet design. The default design is upserted when data.tier_id is absent or 0;
 * a tier-specific design is upserted when data.tier_id is set.
 *   POST admin/wallet/design/{platform}/{type}
 */
export async function postWalletSetting(platform, type = 'member', data) {
  return postWithCheckingToken(`${API_URI}admin/wallet/design/${platform}/${type}`, {}, data)
}

export async function deleteWalletSetting(platform, type = 'member', tierId) {
  const qs = tierId ? `?tier_id=${tierId}` : ''
  return deleteWithCheckingToken(`${API_URI}admin/wallet/design/${platform}/${type}${qs}`, {})
}

export async function apiGetWebLegals() {
  return postWithCheckingToken(`${API_URI}web-legals`)
}

export async function apiGetLoginSettings(tierToken) {
  return postWithCheckingToken(`${API_URI}login-settings`, {}, tierToken ? {tier_token: tierToken} : {})
}

export function apiApplessRequestOTP(mobile, captcha_token) {
  return postWithCheckingToken(
    `${API_URI}appless/otp`,
    {},
    {
      mobile,
      captcha_token,
    },
  )
}

export function apiApplessRegister(body) {
  return postWithCheckingToken(`${API_URI}appless/register`, {}, body)
}

export function apiApplessProfileUpdate(body) {
  return postFormDataWithCheckingToken(`${API_URI}appless/account/updateprofile`, {}, body)
}

export function apiGetMemberProfile() {
  return postWithCheckingToken(`${API_URI}appless/account/profile`, {}, {})
}

export function getPassInfo() {
  return postWithCheckingToken(`${API_URI}member/wallet/google/generate`)
}

export function getReport({type = 'active', startDate, endDate, period = 'weeks', tier = []}) {
  let tierString = ''
  if (tier.length > 0) {
    tier.forEach((tierId) => {
      tierString = tierString + '&tier[]=' + tierId
    })
  }
  return getWithCheckingToken(
    `${API_URI}admin/report?type=${type}&start_date=${startDate}&end_date=${endDate}&period=${period}${tierString}`,
  )
}
